import ExpandableText from './expandable-text/expandable-text.vue'

import NtAccordion from './nt-accordion/nt-accordion.vue'

import NtAutoComplete from './nt-autocomplete/nt-autocomplete.vue'
import NtAutoComplete2 from './nt-autocomplete/nt-autocomplete2.vue'

import NtContact from './nt-contact/nt-contact.vue'

import NtContent from './nt-content/nt-content.vue'
import NtContentAction from './nt-content/nt-content-action.vue'
import NtContentBackground from './nt-content/nt-content-background.vue'
import NtContentCol from './nt-content/nt-content-col.vue'
import NtContentItem from './nt-content/nt-content-item.vue'
import NtContentList from './nt-content/nt-content-list.vue'
import NtContentListItem from './nt-content/nt-content-list item.vue'
import NtContentRow from './nt-content/nt-content-row.vue'
import NtContentTaxonomy from './nt-content/nt-content-taxonomy.vue'
import NtContentText from './nt-content/nt-content-text.vue'
import NtContentTitle from './nt-content/nt-content-title.vue'

import NtDecorate from './nt-decorate/nt-decorate.vue'

import NtForm from './nt-form/nt-form.vue'

import NtFormWeblead from './nt-form-weblead/nt-form-weblead.vue'
import NtFormWebleadTemplate from './nt-form-weblead/nt-form-weblead-template.vue'
import NtFormSelectWebLead from './nt-form-weblead/nt-form-select-weblead.vue'
import NtFormCheckLinkWebLead from './nt-form-weblead/nt-form-checklink-weblead.vue'

import NtFormCheckGroup from './nt-form-checkgroup/form-checkgroup.vue'

import NtFormCheckLink from './nt-form-checklink/form-checklink.vue'

import NtFormHidden from './nt-form-hidden/nt-form-hidden.vue'

import NtFormInput from './nt-form-input/nt-form-input.vue'

import NtFormRadioGroup from './nt-form-radiogroup/nt-form-radiogroup.vue'

import NtFormRichText from './nt-form-richtext/nt-form-richtext.vue'

import NtFormSelect from './nt-form-select/form-select.vue'
import NtFormSelectOption from './nt-form-select/form-select-option.vue'

import NtFormSelect2 from './nt-form-select-2/form-select-2.vue'

import NtFormSelect3 from './nt-form-select-3/nt-form-select-3.vue'

import NtFormSubmit from './nt-form-submit/nt-form-submit.vue'
import NtFormISubmit from './nt-form-submit/nt-form-i-submit.vue'

import NtFormTextArea from './nt-form-textarea/form-textarea.vue'

import NtFormUploader from './nt-form-uploader/uploader.vue'

import NtHeader from './nt-header/nt-header.vue'
import NtHeaderDropdown from './nt-header/nt-header-dropdown.vue'
import NtMenu from './nt-header/nt-menu.vue'
import NtMenuItem from './nt-header/nt-menu-item.vue'

import NtNavegableImage from './nt-navegable-image/nt-navegable-image.vue'

import NtPage from './nt-page/nt-page.vue'

import NtPaginator from './nt-paginator/nt-paginator.vue'

import NtFormRecaptcha from './nt-recaptcha/nt-recaptcha.vue'

import NtScrollToTop from './nt-scroll-to-top/nt-scroll-to-top.vue'

import NtSearchPrimary from './nt-search/nt-search-primary.vue'

import NtSearchResults from './nt-search-results/nt-search-results.vue'

import NtSlider from './nt-slider/nt-slider.vue'

import NtTag from './nt-tag/nt-tag'

import NtTemplateItem from './nt-template-item/nt-template-item.vue'

import NtVideoDuration from './nt-video-duration/nt-video-duration.vue'

import Swiper from './swiper/swiper.vue'

import NtQuote from './nt-quote/nt-quote.vue'

import CKicker from './kicker/kicker.vue'

export default [
  ExpandableText,
  NtAccordion,
  NtAutoComplete,
  NtAutoComplete2,
  NtContact,
  NtContent,
  NtContentAction,
  NtContentBackground,
  NtContentCol,
  NtContentItem,
  NtContentList,
  NtContentListItem,
  NtContentRow,
  NtContentTaxonomy,
  NtContentText,
  NtContentTitle,
  NtDecorate,
  NtForm,
  NtFormWeblead,
  NtFormWebleadTemplate,
  NtFormCheckGroup,
  NtFormCheckLink,
  NtFormCheckLinkWebLead,
  NtFormHidden,
  NtFormInput,
  NtFormRadioGroup,
  NtFormRichText,
  NtFormSelect,
  NtFormSelectOption,
  NtFormSelect2,
  NtFormSelect3,
  NtFormSelectWebLead,
  NtFormSubmit,
  NtFormISubmit,
  NtFormTextArea,
  NtFormUploader,
  NtHeader,
  NtHeaderDropdown,
  NtMenu,
  NtMenuItem,
  NtNavegableImage,
  NtPage,
  NtPaginator,
  NtFormRecaptcha,
  NtScrollToTop,
  NtSearchPrimary,
  NtSearchResults,
  NtSlider,
  NtTag,
  NtTemplateItem,
  NtVideoDuration,
  Swiper,
  NtQuote,
  CKicker
]
